import { useRef, useId, useState, useMemo, useEffect } from 'react';
import { useNavigationManager } from '@provider/navigation';
import { units } from '@ui/css';
import { filterOptionsByQuery, Search, Listbox, Button } from '@ui/kit';
import { applyCssDeclarations } from '@utils/css';
import { useKeyListener } from '@utils/react';
import { container, headingCls, search, listbox, buttons, tokens } from './atom.select.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ShareSelect(props) {
  const navigation = useNavigationManager();
  const containerRef = useRef(null);
  const labelId = `share-select-${useId()}`;
  const listboxId = `share-select-listbox-${useId()}`;
  const [isSaving, setSaving] = useState(false);
  const [query, setQuery] = useState("");
  const filteredOptions = useMemo(() => filterOptionsByQuery(props.options, query), [props.options, query]);
  const handleSave = async () => {
    try {
      setSaving(true);
      await props.onSave();
    } finally {
      setSaving(false);
    }
  };
  useMinHeight(containerRef);
  useKeyListener(evt => {
    if (evt.key === "Escape") {
      evt.stopPropagation();
      navigation.push("/");
    }
  }, {
    capture: true,
    disabled: !!query
  });
  return /*#__PURE__*/jsxs("div", {
    ref: containerRef,
    className: container,
    children: [/*#__PURE__*/jsx("h2", {
      id: labelId,
      className: headingCls,
      children: props.label
    }), /*#__PURE__*/jsx(Search, {
      theme: "local",
      placeholder: props.inputPlaceholder,
      "aria-label": props.inputPlaceholder,
      className: search,
      onQueryChange: setQuery
    }), /*#__PURE__*/jsx(Listbox, {
      toggleValue: props.toggleValue,
      selectedValues: props.selectedValues,
      className: listbox,
      options: filteredOptions,
      id: listboxId,
      labelledBy: labelId,
      multiSelect: true
    }), /*#__PURE__*/jsxs("div", {
      className: buttons,
      children: [/*#__PURE__*/jsx(Button, {
        theme: "secondary",
        onClick: props.onCancel,
        disabled: isSaving,
        children: "Tilbage"
      }), /*#__PURE__*/jsx(Button, {
        theme: "primary",
        onClick: handleSave,
        showSpinner: isSaving,
        disabled: props.required && props.selectedValues.length === 0,
        tooltip: props.required ? {
          disabled: props.selectedValues.length !== 0,
          body: props.requiredLabel,
          ariaType: "description"
        } : undefined,
        children: "V\xE6lg"
      })]
    })]
  });
}
function useMinHeight(containerRef) {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }
    applyCssDeclarations(tokens.minHeight.__override(units.px(container.clientHeight)), container);
  }, [containerRef]);
}

export { ShareSelect };
//# sourceMappingURL=atom.select.js.map
